import React, { Component } from "react";
import { Form } from "informed";
import { Link } from "react-router-dom";
import { policyChanges } from "../../../api/pets-api";
import Helpers from "../../common/util/Helpers";
import ErrorView from "../../common/error-view/ErrorView";
import Loader from "../../common/loader/Loader";
import CheckboxControl from "../../common/form-fields/checkbox/Checkbox";
import PetPolicyRate from "../change-policy-options/PetPolicyRate.component";

import "./ChangeAnniversaryPolicyOptions.component.css";
import Util from '../../common/util/util';
import { AppLinks } from "../../../constants/app-links";
import NoOptionsPetPlan from "../change-policy-options/NoOptionsPetPlan.component";


class ChangeAnniversaryPolicyOptions extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedPlans: this.getCurrentPlans(),
      submitError: false,
      submitLoader: false,
      resetAll: false,
      checkboxChecked: false,
      limitedOptionPets: this.getLimitedOptionPets(),
      multipleOptionPolicies: this.getMultipleOptionPolicies()
    }
    this.submitErrorMessage = "";
    this.resetRef = [];

    // Iterate throught the PolicyChangedPets JSON object and create a map of petId (key) and initial monthly total rate (value)  for each pet
    this.initialMonthlyRateMap = this.props.userAccountDetails.PolicyChangedPets.map(pet => {
      return { petId: pet.PetId, monthlyTotalRate: pet.Premium };
    });

    this.getTotalMonthlyRate();
  }

  resetAll = (event) => {
    this.resetRef && this.resetRef.length && this.resetRef.forEach(ref => ref && ref.reset());
    event.preventDefault();
  }

  setRef = (instance) => {
    if (instance && !this.resetRef.find(ref => ref.props.id === instance.props.id)) {
      this.resetRef.push(instance);
    }
  }

  // returns a map of petId and current plan.  If current plan is undefined, the pet's current plan is not available as a new selection
  getCurrentPlans = () => {
    const petArray = this.props.availablePolicies.map(options => {
      if (options.policies.length > 1) {
        const currentPlan = options.policies.find(policy => policy.is_current_plan);
        return { policy: currentPlan, pet: { pet_id: options.pet.pet_id } }
      }
      return null;
    });
    return petArray.filter(pet => pet !== null);
  }

  getMultipleOptionPolicies = () => {
    return this.props.availablePolicies.filter(policy => policy.policies.length > 1);
  }

  getLimitedOptionPets = () => {
    const petArray = this.props.availablePolicies.map(policy => {
      if (policy.policies.length === 1) {
        const pet = this.props.petDetails.find(pet => pet.PetID === policy.pet.pet_id);
        
        // update the pet with the reimburesment, deductible, and premium values from the available policy options 
        pet.Reimbursement = policy.policies[0].reimbursement*100 + "%";
        pet.Deductible = Helpers.formatCurrency(policy.policies[0].deductible, false);
        pet.MonthlyPremium = Helpers.formatCurrency(policy.policies[0].monthly_total_payment);
        return pet;
      }
      return null;
    })

    return petArray.filter(pet => pet !== null);
  }

  getTotalMonthlyRate = () => {

    // get the total monthly rate for the selected plans and the limited option pets
    let monthlyRate = 0.00;
    if (this.state.selectedPlans && this.state.selectedPlans.length > 0 && this.state.selectedPlans[0] != null) {
      monthlyRate += this.state.selectedPlans.reduce((acc, plan) => {
        if (plan && plan.policy && plan.policy.monthly_total_payment) {
          return acc + Number(String(plan.policy.monthly_total_payment).replace("$","").replace(",",""))
        } else {
          const initialMonthlyRate = this.initialMonthlyRateMap.find(pet => pet.petId === plan.pet.pet_id);
          return acc + Number(initialMonthlyRate.monthlyTotalRate);
        }
      }, 0);
    }
    if (this.state.limitedOptionPets && this.state.limitedOptionPets.length > 0 && this.state.limitedOptionPets[0] != null) {
      monthlyRate += this.state.limitedOptionPets.reduce((acc, pet) => {
        if (pet && pet.MonthlyPremium) {
          return acc + Number(String(pet.MonthlyPremium).replace("$","").replace(",",""))
        } else {
          const initialMonthlyRate = this.initialMonthlyRateMap.find(pet => pet.petId === pet.PetID);
          return acc + Number(initialMonthlyRate.monthlyTotalRate);
        }
      }, 0);
    }
    this.monthlyTotalRate = monthlyRate;
  };


  updateSelectedPlan = (changedPlan, pet_id) => {
    const selectedPlans = this.state.selectedPlans;
    selectedPlans.map(plan => {
      if (plan && plan.pet && plan.pet.pet_id === pet_id) {
        plan.policy = changedPlan;
      }
    });

    this.setState({ selectedPlans: selectedPlans });

    this.getTotalMonthlyRate();
  }

  changePolicyOptions = () => {
    this.setState({ submitLoader: true });
    // filter out plans that have a null policy or are not the current plan
    const changedPolicyOptions = this.state.selectedPlans.filter(plan => plan.policy && !plan.policy.is_current_plan);
    changedPolicyOptions.length > 0 && policyChanges(changedPolicyOptions, true)
      .then(response => {
        this.setState({ submitLoader: false });

        this.props.setAccountDataRefresh();
        this.props.getAlertsByAccount();
        this.getTotalMonthlyRate();
        this.props.onPolicyChangeSuccess(response, this.monthlyTotalRate);
      })
      .catch(error => {
        this.submitErrorMessage = error.errorMessage ? error.errorMessage : "Could not change your policy options. Please try later.";
        this.setState({ submitError: true, submitLoader: false });
        window.scrollTo(0,0);
      });
  }

 // handle checkbox click
 handleFormChange = (event) => {
  if(event.values.checkbox != undefined)
  {
    this.setState({checkboxChecked : event.values.checkbox});
  }   
  
}
  petPolicyOptionSelector = (availablePolicies) => {
    const { petDetails } = this.props;
    return (
      <div className="pet-policy-rates-content">
        {petDetails.map((pet, index) => {
          const policyOptionsForEachPet = availablePolicies.find(options => options.pet["pet_id"] === pet.PetID);
          if (policyOptionsForEachPet) {
            return (<PetPolicyRate
              id={"petPolicyRate-" + index}
              ref={(instance) => { this.setRef(instance) }}
              key={index}
              pet={pet}
              policyOptions={policyOptionsForEachPet}
              updateSelectedPlan={this.updateSelectedPlan}
              effectiveDate={this.props.userAccountDetails.NextAnniversaryDate}
              resetLabel={'Reset To Original Plan Options'}
            />);
          }
          return null;
        })}
      </div>
    );
  };

  petPlanList = () => {
    if (this.state.limitedOptionPets && this.state.limitedOptionPets.length > 0 && this.state.limitedOptionPets[0] != null) {
      const result = this.state.limitedOptionPets.map((pet) => {
          return (
              <NoOptionsPetPlan key={pet.PetID} plan={pet} policyEffectiveDate={this.props.userAccountDetails.NextAnniversaryDate} />
          );
      })
      return result;
    }
    return null;
  };

  render() {
    let checkboxLabel;
    const { availablePolicies, petDetails, policyEffectiveDate } = this.props;
    const singlePolicyList = availablePolicies.filter(policyOptions => policyOptions.policies.length === 1);
    const termsConditionText = `By checking this box and clicking "Change Policy Options", I certify that the information provided is accurate to the best of my knowledge. I authorize any veterinary hospital or veterinarian to provide additional information about my pet to Healthy Paws Pet Insurance. I understand that missing information or delays in delivering the pet's medical records may delay the processing of my claim. Claims must be submitted for processing within 90 days of invoice date.`;
    if (window.matchMedia("(min-width: 768px)").matches) {
      checkboxLabel = "I agree to these terms and conditions";
    } 
    else {
      checkboxLabel = "I agree to these terms";
    }
    return (
      <div className="container change-policy-options">
        {this.state.submitLoader && <Loader position="absolute" fullPage={true} />}
      
        <h1 className="text-primary mb-3 mb-lg-0">Annual Policy Renewal Options</h1>
        {this.state.submitError && <ErrorView>{this.submitErrorMessage}</ErrorView>}
        <React.Fragment>
          <div className="row">
            <div className="col-lg-8">
              <React.Fragment>
                <p className="d-block d-md-none d-lg-block black-text">
                  Your annual policy renewal is coming up on {Util.getFormattedDate(this.props.userAccountDetails.NextAnniversaryDate)}. If there are options to adjust your pet's coverage (based upon their details and claim history), you will see those options below.* <span  className="red-text">Any policy changes you make today will be effective on {Util.getFormattedDate(this.props.userAccountDetails.NextAnniversaryDate)}.</span>
                </p>
                <p className="d-none d-md-block d-lg-none black-text">
                  Your annual policy renewal is coming up on {Util.getFormattedDate(this.props.userAccountDetails.NextAnniversaryDate)}. If there are options to adjust your pet's coverage (based upon their details and claim history), you will see those options below.* <span  className="red-text">Any policy changes you make today will be effective on {Util.getFormattedDate(this.props.userAccountDetails.NextAnniversaryDate)}.</span>
                </p>
              </React.Fragment>
              <div>{this.petPolicyOptionSelector(this.state.multipleOptionPolicies)}</div>
              <div className="pet-list-container">
                <div className="row d-flex gx-4">
                  {this.petPlanList()}
                </div>
              </div>
              <div className="d-none d-sm-block">
                <div>
                  <p className="bottom-script">
                    *You may increase or decrease your pet's coverage by changing your deductible amount or reimbursement level at any time prior to filing your first claim. The annual limit you originally selected at enrollment cannot be increased, however your annual limit can be decreased at any time prior to submitting your first claim.
                  </p>
                </div>
              </div>

            </div>
            <div className="col-lg-4">
              <div className="monthly-rate-container mt-3">
              <div class="d-md-none" style={{textAlign:'center',fontSize:'18px',fontWeight:'700',fontFamily:'"Open Sans Semibold", "Open Sans", sans-serif '}}>Agree To Terms & Conditions</div>
                          
                <Form id="confirmChargesForm" onChange={this.handleFormChange} onSubmit={this.changePolicyOptions}>
                  {({ formState, formApi }) => (

                    singlePolicyList.length === availablePolicies.length ?
                      (
                        <div className="rate-container text-center" >
                          <h2 className="d-none d-sm-block font-weight-bold new-premium">
                            New Total Monthly Premium for your Pets
                          </h2>
                          <div className="d-none d-sm-block red-text-notice">
                            Beginning {Util.getFormattedDate(this.props.userAccountDetails.NextAnniversaryDate)}
                          </div>
                          <div className="d-none d-sm-block rate-text-large mb-3" style={{ color: "#999999" }}>
                            ${availablePolicies[0].policies[0].monthly_total_payment.toFixed(2)}
                            <small>/month</small>
                          </div>
                          <Link to="/">
                            <button className="d-none d-sm-block button-secondary">
                              Home
                            </button>
                          </Link>
                          {/* Hiding this as per:  https://www.pivotaltracker.com/story/show/163799900 */}
                          {/* <div className="d-flex mt-3">
                            <div className="mr-2 mr-md-3">
                              <i className="fa fa-info-circle" style={{ fontSize: "23px" }}></i>
                            </div>
                            <div className="text-left" >
                              <strong><span className="truncate">{petDetails[0].Name}</span>'s policy option is limited.</strong>
                              <p>Pets who are 8 years and older are eligible for 60% Reimbursement and $750 Annual Deductible options.</p>
                            </div>
                          </div> */}
                        </div>
                      ) :
                      (
                        <React.Fragment>
                          <div className="rate-container text-center">
                            <h2 className="d-none d-sm-block font-weight-bold d-none d-md-block new-premium">
                              New Total Monthly Premium for your Pets
                            </h2>
                            <h4 className="d-none d-sm-block font-weight-bold d-md-none text-primary">
                              Total Monthly Rate For Your Pets
                            </h4>
                            <div className="d-none d-sm-block red-text-notice">
                              Beginning {Util.getFormattedDate(this.props.userAccountDetails.NextAnniversaryDate)}
                            </div>
                            <div className="d-none d-sm-block rate-text-large mb-3">
                              {Helpers.formatCurrency(this.monthlyTotalRate)}
                              <small>/month</small>
                            </div>
                            <div className="text-left">
                              <textarea
                                className="terms-conditions w-100 mb-1"
                                readOnly
                                value={termsConditionText}
                              />
                              <CheckboxControl
                                className="mb-3"
                                id="checkbox"
                                field="checkbox"
                                label={checkboxLabel}
                              />
                            </div>

                            <div className="row">
                              <div className="col-md-8  col-lg-12 mb-2">
                                <button
                                  className="d-none d-sm-block change-policy-button-primary"
                                  type="submit"
                                  disabled={!formState.values.checkbox || this.state.selectedPlans.filter(plan => plan.policy != undefined ? !plan.policy.is_current_plan : false).length === 0}
                                >
                                  Change Policy Options
                                </button>
                              </div>
                              <div className="col-md-4 col-lg-12">
                                <Link to="/">
                                  <button
                                    className="cancel-button-link"
                                    type="button"
                                  >
                                    Cancel
                                  </button>
                                </Link>
                              </div>
                            </div>
                          </div>
                          <div className="d-block d-lg-none effective-details d-flex" style={{ background: '#fff', marginTop: '-30px' }}>
                            <p style={{
                              color: '#2B373A',
                              fontFamily: 'Open Sans',
                              fontSize: '13px',
                              fontStyle: 'normal',
                              fontWeight: '400',
                              lineHeight: '150%',
                              marginBottom: '0'
                            }}>
                             *You may increase or decrease your pet's coverage by changing your deductible amount or reimbursement level at any time prior to filing your first claim. The annual limit you originally selected at enrollment cannot be increased, however your annual limit can be decreased at any time prior to submitting your first claim.
                            </p>

                          </div>
                          <div className="please-note-title pl-3 mb-lg-0">
                            <strong>Please Note:</strong>
                          </div>
                          <div className="please-note-list fs-12 fs-md-14 mb-md-0 mb-lg-3">
                            <ul>
                              <li>
                                Subject to state law requirements, card payments will be processed by One Inc, a third-party payment processor, and a processing fee of 2.99% will be charged for using their digital payment platform.
                              </li>
                              <li>
                                To avoid the fee associated with paying by card through the One Inc. platform, you can choose to pay via bank account (ACH). Please visit the <Link style={{ textDecoration: "underline", fontWeight: "bold", fontSize: "inherit", color:"#6B61F2"}} to={AppLinks.account.updateBillingInfo}>Manage Payments</Link> page to update your payment method.
                              </li>
                            </ul>
                          </div>
                        </React.Fragment>
                      )

                  )}
                </Form>
              </div>
            </div>
          </div>
        </React.Fragment>
        <div className="d-md-none sticky-bottom">
                        <div className="col-md-8 p-0">
<div className="d-md-none text-center sticky-bottom-title" style={{color:'#E00043', fontSize:'16px',fontWeight:600}}>New Monthly Premium for your Pets</div>
                            <div className="d-md-none text-center"><span className="font-weight-bold sticky-bottom-rate-text">{Helpers.formatCurrency(this.monthlyTotalRate)}</span><small>/month</small></div>
<button
                                  className="button-primary"
                                  type="submit"
                                  style={{fontSize:'16px'}}
                                  disabled={!this.state.checkboxChecked || this.state.selectedPlans.filter( plan => plan.policy != undefined ? !plan.policy.is_current_plan : false).length === 0}
                                  onClick={this.changePolicyOptions}>
                                  Change Policy Options
                                </button>
                        </div>
                    </div>
      </div>
    );
  }
}

export default ChangeAnniversaryPolicyOptions;